module.exports = __webpack_public_path__ + "static/media/it-IT.f04de15f.svg";